import { useState } from 'react';
import type { ReactNode } from 'react';
import './components.css';

export interface TabItem {
  key: string;
  label: ReactNode;
  badge?: ReactNode;
  content: ReactNode;
}

interface TabsProps {
  items: TabItem[];
  defaultKey?: string;
  activeKey?: string;
  onChange?: (key: string) => void;
}

export function Tabs({ items, defaultKey, activeKey, onChange }: TabsProps) {
  const [internalActive, setInternalActive] = useState(defaultKey ?? items[0]?.key ?? '');
  const active = activeKey ?? internalActive;
  const cur = items.find((i) => i.key === active) ?? items[0];

  return (
    <div className="iris-tabs">
      <div className="iris-tabs-list" role="tablist">
        {items.map((it) => (
          <button
            key={it.key}
            type="button"
            role="tab"
            aria-selected={it.key === active}
            className={`iris-tab ${it.key === active ? 'active' : ''}`}
            onClick={() => {
              if (activeKey === undefined) setInternalActive(it.key);
              onChange?.(it.key);
            }}
          >
            <span>{it.label}</span>
            {it.badge && <span className="iris-tab-badge">{it.badge}</span>}
          </button>
        ))}
      </div>
      <div className="iris-tabs-panel" role="tabpanel">
        {cur?.content}
      </div>
    </div>
  );
}
